import postRequest from '../../../../../../../postRequest';

/**
 * Bulk upload product name.
 *
 * @param {number} SiteId Site Id
 * @param {number} LanguageId Language Id
 * @param {file} File Either a csv or excel file
*/
export default function postProductNamesProductId({
  SiteId,
  LanguageId,
  File,
}) {
  const endpoint = '/oc-product-bulkapi/v1/bulk-process/product-names/product-id';

  const body = new FormData();
  body.append('SiteId', SiteId);
  body.append('LanguageId', LanguageId);
  body.append('File', File);

  return new Promise((resolve, reject) => {
    postRequest(
      endpoint,
      body,
      'Product Name (ProductID)',
      'STARTED: Product Name',
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
